import { render, staticRenderFns } from "./homeNotice.vue?vue&type=template&id=c73df7d4&scoped=true&"
import script from "./homeNotice.vue?vue&type=script&lang=js&"
export * from "./homeNotice.vue?vue&type=script&lang=js&"
import style0 from "./homeNotice.vue?vue&type=style&index=0&id=c73df7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73df7d4",
  null
  
)

export default component.exports